// src/adminComponents/aDashboard/OverallStats.js
import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, Avatar, Button } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase'; // Adjust the path to your firebase config
import { textFieldStyles } from '../../Login/LoginPageStyles';

const OverallStats = ({ onManageUsersClick }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const employeesCollection = collection(db, 'employees');
        const employeeSnapshot = await getDocs(employeesCollection);
        const employeeList = employeeSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setEmployees(employeeList);
      } catch (error) {
        console.error("Error fetching employees: ", error);
      }
    };

    fetchEmployees();
  }, []);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to the first page when the search query changes
  };

  const filteredData = employees.filter((user) =>
    user.id.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.position.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const displayedData = filteredData.slice(
    page * rowsPerPage,
    (page + 1) * rowsPerPage
  );

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>
      <Box
        sx={{
          backgroundColor: 'white',
          borderRadius: 2,
          padding: 3,
        }}
      >
        <Typography variant="h5">Employees</Typography>
        <Box
          sx={{
            padding: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <TextField
            label="Search Employees by ID, Name or Position"
            variant="outlined"
            value={searchQuery}
            onChange={handleSearchChange}
            sx={{ ...textFieldStyles, width: '400px', marginY: '2' }}
          />
          <Button variant="contained" sx={{ backgroundColor: '#39B54A', '&:hover': { backgroundColor: '#2c8f39' } }} startIcon={<GroupIcon />} onClick={onManageUsersClick}>
            MANAGE EMPLOYEES
          </Button>
        </Box>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left"><b>Employee Id</b></TableCell>
              <TableCell align="left"><b>Employee Name</b></TableCell>
              <TableCell align="left"><b>Position</b></TableCell>
              <TableCell align="center"><b>Total Working Hours</b></TableCell>
              <TableCell align="center"><b>Average Working Hours</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedData.map((user, index) => (
              <TableRow key={index}>
                <TableCell align="left">{user.id}</TableCell>
                <TableCell align="center">
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar src={user.avatar} sx={{ marginRight: 1, width: 60, height: 60 }} />
                    {user.name}
                  </Box>
                </TableCell>
                <TableCell align="left">{user.position}</TableCell>
                <TableCell align="center">{user.totalHours}</TableCell>
                <TableCell align="center">{user.avgHours}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 1, marginBottom: 2 }}>
          <TablePagination
            component="div"
            count={filteredData.length}
            page={page}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
            rowsPerPageOptions={[5, 10, 25]} // Example options
          />
        </Box>
      </Box>
    </div>
  );
};

export default OverallStats;
